import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import axiosInstance from "../../../api/axiosInstance";

export const updateCandidateStatus = createAsyncThunk(
  "recruiter/updateCandidateStatus",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.updatestatusofcandidateinrecruiter,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const candidateListSlice = createSlice({
  name: "candidatelist",
  initialState: {
    statusUpdateSuccess: false,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCandidateStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCandidateStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.statusUpdateSuccess = true;
      })
      .addCase(updateCandidateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error updating candidate status";
      });
  },
});
export default candidateListSlice.reducer;
